import React from 'react'
import TextField from '@mui/material/TextField'

import { PROFILE_SECURITY_FIELD_SX } from '../constants/profileSecurityConstants'

export default function ProfileSecurityStyledField(props) {
  return (
    <TextField
      fullWidth
      size="small"
      InputLabelProps={{ shrink: true }}
      sx={PROFILE_SECURITY_FIELD_SX}
      {...props}
    />
  )
}
